export default "__VITE_ASSET__EcOVthwh__"